export const SCREEN_CHANGE = 'SCREEN_CHANGE';

export default SCREEN_CHANGE;
